import { render } from "./HoldsCancelled.vue?vue&type=template&id=18ebffe4&scoped=true&ts=true&lang=pug"
import script from "./HoldsCancelled.vue?vue&type=script&lang=ts&setup=true"
export * from "./HoldsCancelled.vue?vue&type=script&lang=ts&setup=true"

import "./HoldsCancelled.vue?vue&type=style&index=0&id=18ebffe4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ebffe4"]])

export default __exports__